const storageKey = (companyId: number) => `o2g-show-company-logo-in-menu:${companyId}`;

export const COMPANY_LOGO_MENU_EVENT = 'company-logo-menu';

export const isCompanyLogoShownInMenu = (companyId?: number | null): boolean => {
  if (!companyId || typeof window === 'undefined') {
    return false;
  }

  const stored = window.localStorage.getItem(storageKey(companyId));
  if (stored === null) {
    return true;
  }

  return stored === '1';
};

export const setCompanyLogoShownInMenu = (companyId: number, show: boolean) => {
  window.localStorage.setItem(storageKey(companyId), show ? '1' : '0');
  window.dispatchEvent(new CustomEvent(COMPANY_LOGO_MENU_EVENT));
};
